export const EMAIL_PATTERN = /^(?!\.)+(?!.*\.@)(?!.*\.\.)(?!.*@-)(?!.*\.web$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/;
// at least one uppercase letter one number and one special character
export const TA_PASSWORD_PATTERN = /^(?=.*[A-Z]+)(?=.*\W+)(?=.*\d+)[\w\d\W]+$/;
export const NUMBER_PATTERN = /^[0-9]*$/;

// minimum Ten characters, at least one uppercase letter,one lowercase letter, one number , one special character.
export const PASSWORD_PATTERN = /^(?=([^A-Z]*[A-Z]){1,})(?=([^a-z]*[a-z]){1,})(?=([^0-9]*\d){1,})(?=([\w]*\W){1,}).{10,}$/;
// minimum Twelve characters, at least one uppercase letter,one lowercase letter, one number , one special character.
export const PCI4_PASSWORD_PATTERN = /^(?=([^A-Z]*[A-Z]){1,})(?=([^a-z]*[a-z]){1,})(?=([^0-9]*\d){1,})(?=([\w]*\W){1,}).{12,}$/;
